<div>
    <div>Hello from supplier mode!</div>
</div>
